import { memoize } from 'lodash';
import luhnCheck from './luhnCheck';
import stripSeparators from './stripSeparators';
import { type } from 'modules/util/typecheck';

const cardNumberRegex = /^\d{10,16}$/;

export const validateCardNumber = memoize((input) => {
  const stripped = stripSeparators(input);
  return cardNumberRegex.test(stripped) && luhnCheck(stripped);
});

const cvcRegex = /^\d{3,4}$/;

export const validateCvc = memoize((input) => {
  return cvcRegex.test(input);
});

const monthRegex = /^(01|02|03|04|05|06|07|08|09|10|11|12)$/;
const yearRegex = /^(\d{2}|\d{4})$/;

const parseAndValidateDate = (month, year) => {
  const monthInt = parseInt(month, 10);
  const yearInt = parseInt(year, 10);
  if (type.isNaN(monthInt) || type.isNaN(yearInt)) return false;

  const normalizedYearInt = year.length === 2 ? 2000 + yearInt : yearInt;

  const today = new Date();
  const todayNormalized = new Date(today.getFullYear(), today.getMonth());
  const expiration = new Date(normalizedYearInt, monthInt - 1);
  return todayNormalized <= expiration;
};

export const validateExpiration = memoize((month, year) => {
  return monthRegex.test(month)
    && yearRegex.test(year)
    && parseAndValidateDate(month, year);
}, (month, year) => {
  return month.toString() + year.toString();
});
